import './layover_component.scss'
import { html } from 'd3-fetch'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['content']
  static classes = ['open', 'large']
  static values = { path: String }

  connect = (): void => {
    if (this.isLarge) this.element.classList.add(this.largeClass)
  }

  load = (nodeId: string, action: string): void => {
    if (this.invalid(action)) return

    if (this.hasTable && this.isLarge) this.tableController.decrease()
    this.pathValue = this.buildPath(this.depotId, nodeId, action)

    const pathWithoutLayout = `${String(this.pathValue)}?layout=false`

    html(pathWithoutLayout).then(data => {
      this.removeActionClasses(action)
      this.contentTarget.innerHTML = ''
      this.contentTarget.append(...data.body.childNodes)
      this.element.scroll({ top: 0, behavior: 'smooth' })
    }).catch((error) => {
      console.error(error)
    })
  }

  clear = (): void => {
    this.element.classList.remove(this.openClass)
    if (this.hasTable) this.tableController.increase()
    this.contentTarget.innerHTML = ''
  }

  fullscreen = (): void => {
    window.location.href = this.pathValue
  }

  removeActionClasses = (action: string): void => {
    this.element.classList = 'layover'
    this.element.classList.add(this.openClass)
    this.element.classList.add(`layover--${action}`)
    if (this.isLarge) this.element.classList.add(this.largeClass)
  }

  invalid = (action: string): boolean => {
    if (['show', 'card', 'edit'].includes(action)) return false
    return true
  }

  buildPath = (depotId: string, nodeId: string, action: string): string => {
    const basePath = `/depots/${depotId}/nodes/${nodeId}`
    if (action === 'show') return `${basePath}`
    return `${basePath}/${action}`
  }

  get depotId (): string {
    const pathNames = window.location.pathname.split('/')
    return pathNames.filter((name, i) => pathNames[i - 1] === 'depots')[0]
  }

  get isLarge (): boolean {
    return document.getElementsByClassName('menu').length === 1
  }

  get tableController (): object {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('table'), 'table')
  }

  get hasTable (): boolean {
    return this.tableController !== undefined && this.tableController !== null
  }
}

// Load show action upon successful edit inside layover
document.addEventListener('ajax:success', e => {
  layoverController().load(e.detail[0].id, 'show')
})

const layoverController = (): object => {
  return globalThis._APPLICATION_.getControllerForElementAndIdentifier(document.getElementById('layover'), 'layover')
}
